import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-changes-holes',
  templateUrl: './changes-holes.component.html',
  styleUrls: ['./changes-holes.component.scss'],
})
export class ChangesHolesComponent implements OnInit {
  @Input() header:string;
  @Input() message:string;
  @Input() showConfirmBtn: boolean = true;
  @Input() isStartScoring: boolean = false;
  @Input() goStartScoring:() => void;

  constructor(
    private modalCtl: ModalController 
  ) { }

  ngOnInit() {}
  
  cancel(){
    this.modalCtl.dismiss();
  }

  confirm(){
    if(this.isStartScoring){
      this.modalCtl.dismiss();
      this.goStartScoring();
    }else{
      const obj = { confirm: true };
      this.modalCtl.dismiss(obj);
    }
  }

}
